const comments = [
  {
    id: 1,
    name: '追剧小达人',
    text: '自从发现了51影视，再也不用到处找资源了！画质清晰不卡顿，每天更新速度也很快，追《长安十二时辰》的时候简直停不下来，强烈推荐给所有剧荒的朋友！',
    drama: '长安十二时辰',
    time: '2小时前',
  },
  {
    id: 2,
    name: '深夜剧迷',
    text: '用了大半年了，51影视的片源真的很全。最近在补《狂飙》，全集高清免费看，缓冲速度也快，比那些收费平台良心太多了。支持51影视一直做下去！',
    drama: '狂飙',
    time: '5小时前',
  },
  {
    id: 3,
    name: '追风少年',
    text: '真心不错的一个平台。最近在追的《繁花》就是在这里看的全集，画质1080P很满意，手机和平板都能流畅播放。已经推荐给身边好几个朋友了，大家都说好！',
    drama: '繁花',
    time: '昨天',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自追剧同好们的真实分享，一起发现更多好剧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((c) => (
            <div
              key={c.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 font-medium text-sm font-heading">
                    {c.name[0]}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{c.name}</p>
                  <p className="text-xs text-foreground-500">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {c.text}
              </p>
              <span className="inline-block px-2.5 py-1 bg-accent-50 text-accent-700 text-xs rounded-full">
                正在追《{c.drama}》
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}